<div class="chart-container">
  <h3 class="chart-title">{{ title }}</h3>
  <div class="chart-wrapper">
    <canvas type="bar" [data]="barChartData" [options]="barChartOptions" baseChart> </canvas>
  </div>
</div>
